import { useMemo } from 'react';
import { useParams } from 'react-router';

import { z } from 'zod';

export const useSanitizedParams = <T extends Record<string, unknown>>(
  sanitizer: z.ZodType<T, z.ZodTypeDef, unknown>
) => {
  const params = useParams();
  const sanitizedParams = useMemo(() => {
    const decoded = Object.fromEntries(
      Object.entries(params).map(([key, value]) => [
        key,
        value !== undefined ? decodeURIComponent(value) : value,
      ])
    );
    return sanitizer.parse(decoded);
  }, [params, sanitizer]);

  return sanitizedParams;
};
